var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.companyCategories.length)?_c('apexchart',{attrs:{"type":"bar","height":Math.max(300, _vm.companyCategories.length * 44 + 80),"options":_vm.companiesOpts,"series":_vm.companiesSeries}}):_c('empty-state',{attrs:{"icon":"mdi-domain","title":_vm.$t('no_data')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }